<ng-container *ngIf="jumpBackInItems$ | async as jumpBackInItems; else loading">
    <ng-container *ngIf="(jumpBackInItems$ | async)?.length > 0">
        <div class="jump-back-in-section">
            <app-subpage-header #jumpBackInHeaderRef [title]="title" size="small"></app-subpage-header>
            <ul>
                <li
                    [id]="item.id"
                    *ngFor="let item of jumpBackInItems | slice: 0 : length; let i = index; trackBy: trackByItem"
                    [class.is-education-course]="item?.education?.isEducationCourse"
                    (click)="onCardClick(item)">
                    <span class="tag">{{ item?.title | uppercase }}</span>
                    <h5>{{ item?.name }}</h5>
                    <span
                        class="points-tag"
                        *ngIf="item?.points > 0 && !item?.education?.showPoints && !item?.supportCase?.status"
                        >+{{ item?.points }} points</span
                    >
                    <span class="points-tag" *ngIf="item?.supportCase?.status"
                        ><b>Case Status</b>: {{ item?.supportCase?.status }}</span
                    >
                    <div class="progess-bar-area" *ngIf="item?.showProgressIndicator">
                        <app-progress-bar-indicator
                            *ngIf="item?.percentComplete > 0"
                            [percentComplete]="item?.percentComplete"></app-progress-bar-indicator>
                    </div>
                    <div class="case-subject-area" *ngIf="item?.supportCase?.subject">
                        <b>Subject</b>: {{ item.supportCase.subject }}
                    </div>
                    <div class="cta-wrapper">
                        <a
                            class="no-underline"
                            (click)="onCardClick(item)"
                            [matTooltip]="item?.name"
                            [matTooltipShowDelay]="1000"
                            [matTooltipHideDelay]="2000">
                            {{ item?.label }}
                            <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                        </a>
                    </div>
                </li>
            </ul>
            <ng-container *ngIf="isLoadMoreDisplay">
                <app-load-more-button
                    [length]="length"
                    [max]="max"
                    [modifier]="modifier"
                    [disabled]="false"
                    [headerRef]="jumpBackInHeaderRef"
                    (refreshLengthFn)="refreshLength($event)"></app-load-more-button>
            </ng-container>
        </div>
    </ng-container>
</ng-container>
<ng-template #loading>
    <ul class="loading">
        <!--TODO: Create new loading row skeleton card-->
        <li *ngFor="let l of [1, 2, 3]">
            <app-loading-skeleton class="tag" [rows]="1" [rowHeight]="16"></app-loading-skeleton>
            <h5><app-loading-skeleton [rows]="1" [rowHeight]="20"></app-loading-skeleton></h5>
            <app-loading-skeleton class="flex" [rows]="1" [rowHeight]="20"></app-loading-skeleton>
            <div class="cta-wrapper">
                <app-loading-skeleton class="cta-wrapper" [rows]="1" [rowHeight]="20"></app-loading-skeleton>
            </div>
        </li>
    </ul>
</ng-template>
